/*Post message event types*/
export const ADD_AZURE_AD_CANCELED = "addAzureAD_canceled";
export const ADD_SP_METADATA_SAVED = "add_sp_metadata_saved";
export const ANY_ORIGIN = "*";
export const APP_LIST = "app_list";
export const APP_LIST_EXTENDED = "app_list_extended";
export const APP_LOADED = "app_loaded";
export const CANCEL_ADD_SAML = "cancel_add_saml";
export const CANCEL_SAVE_CUSTOMIZATION = "cancel_save_customization";
export const DELETE_APP_FAIL = "delete_app_fail";
export const DELETE_APP_OK = "delete_app_ok";
export const DELETE_AZURE_AD_FAIL = "deleteAzureAD_fail";
export const DELETE_AZURE_AD_OK = "deleteAzureAD_ok";
export const DELETE_AZURE_AD_FAIL_NOT_FOUND = "deleteAzureAD_fail_not_found";
export const GET_APP_IDS = "get_app_ids";
export const GET_APPLICATION_LIST = "get_applications_list";
export const GET_APPLICATION_LIST_SUBSCRIBED = "get_applications_list_subscribed";
export const MESSAGE_EVENT_TYPE = "message"
export const APP_CHECK_RESULT = "app_check_result";
export const APP_CHECK_LOADED = "app_check_loaded";
export const APP_CHECK_UNLOADED = "app_check_unloaded";
export const OPEN_HELP_DOC_PAGE = "open_help_doc_page";
export const REDIRECT_TO_WORKFLOW_POLICY_PAGE = "redirect_to_workflow_policy_page";

/*Content types for HTTP requests*/
export const APPLICATION_JSON_CONTENT_TYPE = "application/json";
export const MULTIPART_FORM_DATA_CONTENT_TYPE = "multipart/form-data";

/*HTTP methods for requests*/
export const DELETE = "delete";
export const POST = "post";
export const PUT = "put";
export const GET = "get";

/*Session storage items labels*/
export const AUTH_SESSION_TOKEN = "authSessionToken";
export const APPLIANCE_URL = "applianceUrl";
export const MAPPED_CAPABILITIES = "mappedCapabilities";
export const EXTENDED_ATTRIBUTES = "extendedAttributes";
